<template>
  <div class="index-page">
    <div class="router-view-wrapper">
      <keep-alive :include="['Home', 'Hot',  'Apps', 'ShorVideoSearch', 'Community','Publish', 'longVideoSearch']">
        <router-view class="router-view" />
      </keep-alive>
    </div>
    <public-footer />
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
    };
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.index-page {
  width: 100%;
  height: 100%;

  .router-view-wrapper {
    width: 100%;
    height: 100%;
  }
}
</style>
